import * as getTier from './getTier';
import * as getTiers from './getTiers';
import * as getTypes from './getTypes';

export default {
  ...getTier,
  ...getTiers,
  ...getTypes,
};
